import { BaseAPI } from "@utils/base-api";

import {
  ITikTokEventTrackBaseRequest,
  ITikTokEventTrackResponse,
} from "./types/track-event.types";
import { TRACK_EVENT_ENDPOINT } from "./constants/endpoint-paths";

export class TikTokClient extends BaseAPI {

  public async trackEvent(
    eventData: ITikTokEventTrackBaseRequest,
  ): Promise<ITikTokEventTrackResponse> {
    const config = {
      headers: {
        Accept: "text/*",
      },
      responseType: "text" as const,
    };

    const response = await this.axios.post(
      TRACK_EVENT_ENDPOINT,
      eventData,
      config,
    );

    return response.data;
  }

}
